export const STATE_NAME = 'payoutsCommissionPlan';
